<template>
  <Modal
    :is-open="isOpen"
    size="md"
    @close="handleCancel"
    :close-on-backdrop="true"
    container-class="flex flex-col items-center text-center"
  >
    <div class="flex flex-col items-center text-center justify-center">
      <div
        class="w-16 h-16 bg-yellow-100 text-yellow-600 rounded-full flex items-center justify-center mb-6"
      >
        <AlertCircle :size="32" />
      </div>
      <h3 class="text-xl font-bold text-gray-900 mb-2">Change Location</h3>
      <p class="text-gray-600 mb-8 leading-relaxed">
        Your shopping cart will be reset when changing location. Do you want to
        continue?
      </p>
      <div class="w-full space-y-4">
        <Button variant="primary" size="lg" full-width @click="handleConfirm">
          Confirm
        </Button>
        <Button variant="ghost" size="md" full-width @click="handleCancel">
          Cancel
        </Button>
      </div>
    </div>
  </Modal>
</template>

<script>
import { Modal, Button } from "@/components/ui";
import { AlertCircle } from "lucide-vue";

export default {
  name: "LocationChangeConfirmationModal",
  components: {
    Modal,
    Button
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      AlertCircle
    };
  },
  methods: {
    handleConfirm() {
      this.$emit("confirm");
    },
    handleCancel() {
      this.$emit("cancel");
    }
  }
};
</script>
